import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type SettingsIconProps = Partial<SVGIconProps>;

const SettingsIcon: FC<SettingsIconProps> = (props) => (
  <SVGIcon viewBox="0 0 19 18" {...props}>
    <g id="setting-2">
      <g id="vuesax/linear/setting-2">
        <g id="setting-2_2">
          <path
            d="M9.48828 11.25C10.7309 11.25 11.7383 10.2426 11.7383 9C11.7383 7.75736 10.7309 6.75 9.48828 6.75C8.24564 6.75 7.23828 7.75736 7.23828 9C7.23828 10.2426 8.24564 11.25 9.48828 11.25Z"
            id="Vector"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
          <path
            d="M1.98828 9.6591V8.3391C1.98828 7.5591 2.62578 6.9141 3.41328 6.9141C4.77078 6.9141 5.32578 5.9541 4.64328 4.7766C4.25328 4.1016 4.48578 3.2241 5.16828 2.8341L6.46578 2.0916C7.05828 1.7391 7.82328 1.9491 8.17578 2.5416L8.25828 2.6841C8.93328 3.8616 10.0433 3.8616 10.7258 2.6841L10.8083 2.5416C11.1608 1.9491 11.9258 1.7391 12.5183 2.0916L13.8158 2.8341C14.4983 3.2241 14.7308 4.1016 14.3408 4.7766C13.6583 5.9541 14.2133 6.9141 15.5708 6.9141C16.3508 6.9141 16.9958 7.5516 16.9958 8.3391V9.6591C16.9958 10.4391 16.3583 11.0841 15.5708 11.0841C14.2133 11.0841 13.6583 12.0441 14.3408 13.2216C14.7308 13.9041 14.4983 14.7741 13.8158 15.1641L12.5183 15.9066C11.9258 16.2591 11.1608 16.0491 10.8083 15.4566L10.7258 15.3141C10.0508 14.1366 8.94078 14.1366 8.25828 15.3141L8.17578 15.4566C7.82328 16.0491 7.05828 16.2591 6.46578 15.9066L5.16828 15.1641C4.48578 14.7741 4.25328 13.8966 4.64328 13.2216C5.32578 12.0441 4.77078 11.0841 3.41328 11.0841C2.62578 11.0841 1.98828 10.4391 1.98828 9.6591Z"
            id="Vector_2"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeMiterlimit="10"
          />
        </g>
      </g>
    </g>
  </SVGIcon>
);

export default SettingsIcon;
